import React from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { Calculator, ArrowRight, Check } from 'lucide-react';

export const TaxCredit = () => {
  return (
    <section className="py-20 md:py-24 bg-white font-['Poppins'] relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Left column - Content */}
          <div className="relative">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-[#153254] flex items-start gap-4">
              <span>50% de crédit d'impôt</span>
              {/* Badge 50% positionné à côté du titre */}
              <img 
                src="https://customer-assets.emergentagent.com/job_2513ce8b-8bd6-4c11-809d-00965abc9d4a/artifacts/5kfrh265_50%25%20credit%20d%27impot%20immediat%20png%20custom.png"
                alt="50% crédit d'impôt immédiat"
                className="w-16 h-16 md:w-20 md:h-20 object-contain transform rotate-12 hover:rotate-6 hover:scale-110 transition-all duration-300 drop-shadow-lg cursor-pointer flex-shrink-0"
              />
            </h2>
            
            <p className="text-lg text-[#0A2320] font-semibold mb-6">
              Avec avance immédiate
            </p>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Grâce à l'avance immédiate de crédit d'impôt, vous ne payez que 50% du montant 
              de vos prestations. Plus besoin d'attendre votre déclaration fiscale.
            </p>

            {/* Avantages avec icônes colorées */}
            <div className="space-y-4 mb-10">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#0A2320] to-[#1a4a45] flex items-center justify-center flex-shrink-0 shadow-lg">
                  <Check className="h-5 w-5 text-white" strokeWidth={2.5} />
                </div>
                <span className="text-gray-700">Réduction appliquée directement sur votre facture</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#D4AF37] to-[#e6c555] flex items-center justify-center flex-shrink-0 shadow-lg">
                  <Check className="h-5 w-5 text-white" strokeWidth={2.5} />
                </div>
                <span className="text-gray-700">Sans avance de trésorerie de votre part</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#0A2320] to-[#153254] flex items-center justify-center flex-shrink-0 shadow-lg">
                  <Check className="h-5 w-5 text-white" strokeWidth={2.5} />
                </div>
                <span className="text-gray-700">Démarches simplifiées, nous gérons tout</span>
              </div>
            </div>

            {/* CTAs - BOUTONS VERTS */}
            <div className="flex flex-wrap gap-4">
              <Link to="/devis-premium">
                <Button className="bg-[#0A2320] hover:bg-[#0d2e2a] text-white font-semibold shadow-xl rounded-xl transition-all hover:-translate-y-1" size="lg">
                  <Calculator className="mr-2 h-5 w-5" />
                  Demander un devis
                </Button>
              </Link>
              <Link to="/credit-impot" onClick={() => window.scrollTo(0, 0)}>
                <Button variant="outline" size="lg" className="border-2 border-[#0A2320] text-[#0A2320] hover:bg-[#0A2320] hover:text-white font-semibold rounded-xl">
                  En savoir plus
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>

          {/* Right column - Calculation example */}
          <div className="relative">
            <div className="bg-[#F8FAF9] rounded-3xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold mb-8 text-center text-[#153254]">
                Exemple de calcul
              </h3>
              
              <div className="space-y-5">
                <div className="flex justify-between items-center pb-5 border-b border-gray-200">
                  <span className="text-gray-600">Coût du service</span>
                  <span className="font-bold text-2xl text-gray-800 whitespace-nowrap">100 €</span>
                </div>
                <div className="flex justify-between items-center pb-5 border-b border-gray-200">
                  <span className="text-gray-600">Crédit d'impôt immédiat (50%)</span>
                  <span className="font-bold text-2xl text-[#0A2320] whitespace-nowrap">- 50 €</span>
                </div>
                <div className="bg-gradient-to-r from-[#0A2320] to-[#153254] text-white p-6 rounded-2xl shadow-lg">
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-semibold">Vous payez</span>
                    <span className="text-4xl font-bold">50 €</span>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-4 bg-white rounded-xl border border-gray-100">
                <p className="text-sm text-gray-600 text-center">
                  <strong className="text-[#0A2320]">Avance immédiate :</strong> Vous ne payez que 50€ directement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
